import React from 'react';
import { Button } from 'primereact/button';
import { Content, Parallax } from '../../App';
import Footer from '../../components/Footer';
import {times} from "lodash";

interface ActiviteitenPageProps {
}

type Activity = {
  title: string;
  eyebrow: string;
  date: string;
  time?: string;
  image: string;
  alt: string;
  intro: string;
  paragraphs: string[];
  highlights?: string[];
  buttonLabel?: string;
  buttonDisabled?: true;
  buttonUrl?: string;
  featured?: boolean;
};

const cardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-2',
  'overflow-hidden',
].join(' ');

const sectionCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-1',
  'p-3 pb-2',
].join(' ');

const getActivityId = (activity: Activity) =>
  activity.title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const activityMoreInfoClassName =
  'flex align-items-center gap-2 mt-1 md:mt-3 text-sm font-bold color-orange justify-content-end';


const jubileeInfoCardClassName = [
  'surface-card',
  'border-1',
  'border-200',
  'border-round-2xl',
  'shadow-1',
  'p-4',
  'h-full',
].join(' ');

const jubileeProgram = [
  {
    title: 'Groentebingo',
    icon: 'pi pi-th-large',
    image: '10jaar-bingo.png',
    eyebrow: 'Speel mee',
    time: '14u00 - 16u00',
    paragraphs: [
      'Een feestelijke bingo zoals alleen Groentegeweld die kan bedenken met een flinke knipoog naar het veld.',
      '<strong>Maak kans op een abonnement</strong> en nog vele andere Groentegewelige prijzen!',
    ],
    // highlights: ['Voor jong en oud', 'Met groentegeweldige prijzen'],
  },
  {
    title: 'Veld-BBQ',
    icon: 'pi pi-fire',
    image: '10jaar-bbq.jpeg',
    eyebrow: 'Lekker eten op het veld',
    time: '17u00 - 20u00',
    paragraphs: [
      'We steken de BBQ aan voor een warme, smaakvolle veldmaaltijd. Verwacht pure smaken, groenten in de hoofdrol en een gezellige setting tussen het groen.',
      '25 euro per persoon <br /> <span style="font-size: 90%">(kinderen tot 12 jaar: 12,5 euro)</span>',
      'Inschrijven is niet verplicht, toch zeker zijn van een plaatsje? <a href="mailto:info@groentegeweld.be">Mail ons</a>.',
    ],
    // highlights: ['Veld-BBQ', 'Groenten van het veld', 'Praktische info volgt'],
  },
  {
    title: 'Veldterras & livemuziek',
    icon: 'pi pi-volume-up',
    image: '10jaar-terras.jpeg',
    eyebrow: 'Blijven hangen mag',
    time: '17u00 - 22u00',
    paragraphs: [
      'Ons veldterras wordt de plek om te klinken, bij te praten en te genieten van de sfeer. Neem plaats, bestel iets lekkers en geniet van de muziek.',
    ],
    // highlights: ['Gezellig veldterras', 'Livemuziek', 'Drankjes en sfeer'],
  },
];

const activities: Activity[] = [
  {
    title: 'Yin Yoga op het veld',
    eyebrow: 'Rust, ademruimte en zachte beweging',
    date: 'Dinsdag 2 juni',
    time: '13 weken lang (tot 8 september), telkens op dinsdagavond van 20u tot 21u',
    image: 'lekkerstefeest-yoga.jpg',
    alt: 'Yoga op het veld',
    intro: 'Ben je op zoek naar rust? Voelt je lichaam soms stram aan? Dan kan Yin Yoga een heerlijke oplossing bieden.',
    paragraphs: [
      'Yin Yoga is een rustige vorm van yoga waarbij je enkele minuten in dezelfde houding blijft. Zo krijgt je lichaam tijd om te verzachten en wordt het bindweefsel op een milde manier gerekt.',
      'Deze vorm van yoga vindt haar oorsprong in China en brengt elementen uit Hatha yoga samen met inzichten uit de traditionele Chinese geneeskunde. Het resultaat is een toegankelijke, heilzame praktijk voor iedereen die zichzelf wat vertraging gunt.',
      'En dat alles in de buitenlucht, midden op het veld. Frisse lucht, zachte beweging en de rust van de natuur: een topcombinatie.',
    ],
    highlights: ['Rustige Yin Yoga', 'In de yoga-serre', 'Voor elk niveau'],
    buttonLabel: 'Inschrijven voor yoga',
    buttonUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSep1ppb-8060UvcJ4QEif4g7kgt8IS_cyKhoHZ6IJEUICcCBQ/viewform?usp=header',
  },
  {
    title: 'Houtgebakken pizza met Arthur Pizza',
    eyebrow: 'Pizza, veldterras en seizoensgroenten',
    date: 'vrijdag 3 en 4 juli',
    time: 'vanaf 16u',
    image: 'activiteiten-pizza.jpeg',
    alt: 'Verse tomaten van het veld',
    intro: 'Sara Colin en haar team van Arthur Pizza rijden hun houtoven het veld op voor een avond vol geur, warmte en smaak.',
    paragraphs: [
      'Verwacht heerlijk krokante pizza’s, gebakken in een echte houtoven en belegd met het lekkerste van het veld. Simpel, puur en boordevol smaak.',
      'Je kan gezellig ter plaatse eten op ons veldterras of je pizza komen afhalen om thuis van te genieten. Meer praktische info volgt binnenkort.',
    ],
    highlights: ['Houtoven op het veld', 'Eten of afhalen', 'Met groenten van Groentegeweld'],
    buttonLabel: 'Reserveer je pizza',
    buttonUrl: 'https://webshop.rimbaud-arthur.com/be-nl/brasserie-rimbaud/category/42435/groentegeweld-weelde-27-juni',
  },
  {
    title: 'Proef Lokaal by Pastel',
    eyebrow: 'Verfijnd, cosy en lokaal tafelen',
    date: 'Zaterdag 11 juli',
    time: 'vanaf 18u30, ten laatste starten met eten om 20u00',
    image: 'activiteiten-pastel.jpeg',
    alt: 'Gezellig tafelen op het veldterras',
    intro: 'Pastel - Proef Lokaal komt naar Groentegeweld voor een intieme smaakavond op het veld.',
    paragraphs: [
      '“Onbespoten groenten en fruit uit de kleinschalige landbouw zijn echte smaakbommen”, zo lezen we bij Pastel - Proef Lokaal. En daar zijn wij het uiteraard helemaal mee eens.',
      'Wat André en Lara met die smaakbommen doen, is heerlijk: verfijnd en cosy, zuiders en toch van hier, eerlijk en heerlijk.',
      'We hebben slechts 30 plaatsen, dus snel inschrijven is de boodschap.',
      'Wat krijg je? 5 heerlijke zuiderse gerechtjes, uiteraard met lokale en biologische producten gemaakt geserveerd in onze serre met uitzicht op het veld!',
      'Prijs: € 63 per persoon',
    ],
    highlights: ['Slechts 30 plaatsen', '5 heerlijke zuiderse gerechtjes', 'Culinaire avond op het veld'],
    buttonLabel: 'Inschrijvingen voor het velddiner',
    // buttonDisabled: true,
    buttonUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSe13Rya7BgWIWKasB7J4hSkuFPKsjMh3uUpxx3XyRWhZr8RQQ/viewform',
  },
  {
    title: 'Wildplukwandeling en koken op open vuur',
    eyebrow: 'Met Mike Deroover',
    date: 'Zaterdag 25 juli',
    time: '13u - 18u',
    image: 'activiteiten-mike.jpeg',
    alt: 'Wandeling op en rond het veld',
    intro: 'Ga mee op ontdekkingstocht over het veld en leer opnieuw kijken naar wat de natuur ons schenkt.',
    paragraphs: [
      'Wildplukken is meer dan voedsel verzamelen. Het is vertragen, aandachtig leren kijken en ontdekken welke smaken, geuren en verhalen verscholen zitten in planten waar we anders misschien achteloos voorbij wandelen.',
      'Tijdens deze wandeling neemt Mike Deroover je mee in de wereld van eetbare wilde planten. Je leert herkennen, proeven en begrijpen wat er groeit in en rond het landschap.',
      'Na het wandelen is het tijd om te eten. Of nee: eerst nog bereiden. Samen met Mike ga je aan de slag op open vuur. Puurder en gezelliger wordt het bijna niet.',
    ],
    highlights: ['Maximum 12 deelnemers', 'Wildplukken met gids', 'Samen koken op open vuur'],
    buttonLabel: 'Inschrijven voor de wildplukwandeling',
    buttonUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfx7P1toJkEZq7XnbTVNjbcz8FdPKq2dnbcSjAoHuP6GMLXzg/viewform?usp=header',
  },
  {
    title: 'Workshop tomatensnoei',
    eyebrow: 'Meer lucht, meer licht, sterkere planten',
    date: 'Woensdag 12 augustus',
    time: '19u - 21u',
    image: 'activiteiten-tomaten.jpeg',
    alt: 'Tomaten en vruchtgewassen op het veld',
    intro: 'Tomaten zijn gul, maar ze vragen ook wat aandacht. In deze workshop leer je hoe je je planten gezond, overzichtelijk en productief houdt.',
    paragraphs: [
      'We tonen je hoe je dieven herkent, wanneer je best snoeit en waarom lucht en licht zo belangrijk zijn voor sterke tomatenplanten. Je krijgt praktische tips die je meteen thuis in je serre, tuin of potten kan toepassen.',
      'Geen ingewikkelde theorie, wel duidelijke uitleg tussen de planten. We bekijken verschillende situaties en oefenen samen op het veld.',
      'Ideaal voor iedereen die graag meer uit zijn tomatenplanten haalt en tegelijk ziektes wil voorkomen.',
    ],
    highlights: ['Praktisch en toegankelijk', 'Voor tuin, serre of potten', 'Tips vanop het veld'],
    buttonLabel: 'Inschrijven voor de workshop',
    buttonUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSftlDTFUwN6f90OHJx8ev2C701X2eMxP4hWSwzQC8eqPSggNg/viewform?usp=header',
  },
  {
    title: '10 jaar Groentegeweld feest',
    eyebrow: 'Jubileumfeest op het veld',
    date: 'Zaterdag 5 september',
    image: 'activiteiten-feest.jpeg',
    alt: 'Feest op het veld bij Groentegeweld',
    intro: 'Het is zover: Groentegeweld bestaat 10 jaar en dat vieren we graag samen met iedereen.',
    paragraphs: [
      'Op zaterdag 5 september maken we er een feestelijke dag van op en rond het veld. Verwacht een warme mix van groentebingo, veld-BBQ, veldterras en livemuziek.',
      'Of je nu zelfoogster, pakketklant, buur, vriend of gewoon nieuwsgierig bent: je bent van harte welkom om mee te vieren.',
    ],
    highlights: ['Groentebingo', 'Veld-BBQ', 'Veldterras', 'Livemuziek'],
    featured: true,
  },
  {
    title: 'Workshop bewaren',
    eyebrow: 'Met Queen Katrien',
    date: 'Zaterdag 14 november',
    time: '13u - 15u',
    image: 'activiteiten-bewaren.jpeg',
    alt: 'Verse groenten van het veld',
    intro: 'Leer hoe je de overvloed van het seizoen langer kan vasthouden in je keuken.',
    paragraphs: [
      'In deze workshop neemt Queen Katrien je mee in de wereld van bewaren. Denk aan inmaken, fermenteren, drogen, invriezen: technieken die vroeger vanzelfsprekend waren en vandaag opnieuw super waardevol zijn.',
      'Je krijgt praktische tips om voedselverspilling te vermijden en om ook later op het jaar nog te genieten van de oogst van vandaag.',
      'Een gezellige, leerrijke workshop voor iedereen die graag bewuster kookt en meer uit seizoensgroenten wil halen.',
    ],
    highlights: ['Inmaken en fermenteren', 'Minder voedselverspilling', 'Praktische bewaartips'],
    buttonLabel: 'Inschrijvingen nog niet geopend',
    buttonDisabled: true,
    //buttonUrl: 'https://forms.gle/PLAATS-HIER-DE-GOOGLE-FORM-LINK',
  },
];

const ActiviteitenPage = (props: ActiviteitenPageProps) => {
  const featuredActivity = activities.find(activity => activity.featured);
  const regularActivities = activities.filter(activity => !activity.featured);

  return (
    <div>
      <section className={'grid'}>
        {featuredActivity && (
          <div className="col-12" key={featuredActivity.title}>
            <article
              id={getActivityId(featuredActivity)}
              className={cardClassName + ' h-full flex flex-column'}
            >
              <div
                className="p-4 md:p-5"
                style={{
                  background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.14) 0%, rgba(238, 122, 49, 0.12) 100%)',
                }}
              >
                <div className="grid align-items-center">
                  <div className="col-12 lg:col-7">
                    <div
                      className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                      style={{background: 'var(--orange-20)'}}
                    >
                      <i className="pi pi-star"/>
                      <span className="font-medium">{featuredActivity.eyebrow}</span>
                    </div>

                    <h3 className="mt-0 mb-3 text-4xl md:text-5xl line-height-1 color-orange">
                      10 jaar Groentegeweld
                    </h3>

                    <div className="flex flex-wrap gap-2 mb-4">
                              <span
                                className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl font-medium"
                                style={{
                                  background: 'var(--orange-20)',
                                  color: 'var(--orange)',
                                }}
                              >
                                <i className="pi pi-calendar"/>
                                {featuredActivity.date}
                              </span>

                      <span
                        className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl font-medium"
                        style={{
                          background: 'var(--green-20)',
                          color: 'var(--green)',
                        }}
                      >
                                <i className="pi pi-map-marker"/>
                                Op het veld
                              </span>
                    </div>

                    <p className="text-lg line-height-3 mb-3">
                      {/*{featuredActivity.intro}*/}
                    </p>

                    {featuredActivity.paragraphs.map(paragraph => (
                      <p className="line-height-3 mb-3" key={paragraph}>
                        {paragraph}
                      </p>
                    ))}

                    {featuredActivity.highlights && (
                      <div className="flex flex-wrap gap-2 mt-3">
                        {featuredActivity.highlights.map(highlight => (
                          <span
                            className="px-3 py-2 border-round-3xl font-medium"
                            style={{background: 'rgba(255,255,255,0.70)'}}
                            key={highlight}
                          >
                                    {highlight}
                                  </span>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="col-12 lg:col-5 flex justify-content-center lg:justify-content-end mt-4 lg:mt-0">
                    <img
                      src={'10-jaar-groentegeweld-flyer.jpg'}
                      alt={'Affiche 10 jaar Groentegeweld'}
                      className="block w-full border-round-2xl shadow-2"
                      style={{
                        maxWidth: '420px',
                        maxHeight: '72vh',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <div className="mb-4 flex flex-column align-items-center text-center">
                  <div
                    className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                    style={{background: 'var(--green-20)'}}
                  >
                    <i className="pi pi-list"/>
                    <span className="font-medium">Programma</span>
                  </div>

                  <h4 className="mt-0 mb-2 text-3xl md:text-4xl">
                    Wat staat er op het veld te gebeuren?
                  </h4>

                  <p className="m-0 text-lg line-height-3" style={{maxWidth: '760px'}}>
                    We bouwen een feestelijke dag met rondleidingen, eten, muziek en veel gezelligheid.
                  </p>
                </div>

                <div className="grid">
                  {jubileeProgram.map(programItem => (
                    <div className="col-12 lg:col-4" key={programItem.title}>
                      <div className={jubileeInfoCardClassName + ' overflow-hidden p-0'}>
                        <img
                          src={programItem.image}
                          // alt={programItem.alt}
                          className="block w-full"
                          style={{
                            height: '220px',
                            objectFit: 'cover',
                          }}
                        />

                        <div className="p-4">
                          <div
                            className="flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                            style={{
                              background: 'var(--green-20)',
                              color: 'var(--green)',
                            }}
                          >
                            <i className="pi pi-clock"/>
                            <span className="font-medium">{programItem.time}</span>
                          </div>

                          {/*<div*/}
                          {/*  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"*/}
                          {/*  style={{background: 'var(--orange-20)'}}*/}
                          {/*>*/}
                          {/*  <i className={programItem.icon}/>*/}
                          {/*  <span className="font-medium">{programItem.eyebrow}</span>*/}
                          {/*</div>*/}


                          <h5 className="mt-0 mb-3 text-2xl color-orange">
                            {programItem.title}
                          </h5>

                          {programItem.paragraphs.map(paragraph => (
                            <p className="line-height-3 mb-3" key={paragraph} dangerouslySetInnerHTML={{__html: paragraph}}>
                              {/*{paragraph}*/}
                            </p>
                          ))}

                          <div className="flex flex-wrap gap-2 mt-3">
                            {/*{programItem.highlights.map(highlight => (*/}
                            {/*  <span*/}
                            {/*    className="px-3 py-2 border-round-3xl font-medium"*/}
                            {/*    style={{background: 'var(--green-20)'}}*/}
                            {/*    key={highlight}*/}
                            {/*  >*/}
                            {/*            {highlight}*/}
                            {/*          </span>*/}
                            {/*))}*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          </div>
        )}
      </section>
      <section className="relative overflow-hidden">
        <Parallax img={'activiteiten_hero.jpeg'} height={'50vh'} />
        <div className="absolute top-0 left-0 right-0 bottom-0 flex align-items-center">
          <div
            className="w-full"
            style={{
              background: 'linear-gradient(90deg, rgba(0,0,0,0.84) 0%, rgba(0,0,0,0.54) 58%, rgba(0,0,0,0.12) 100%)',
            }}
          >
            <Content>
              <div className="py-6 md:py-8 text-white" style={{ maxWidth: '820px' }}>
                <div
                  className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
                  style={{ background: 'rgba(255,255,255,0.20)', backdropFilter: 'blur(8px)' }}
                >
                  <i className="pi pi-calendar" />
                  <span className="font-medium">Workshops • eten • beleven • vieren</span>
                </div>

                <h1 className="m-0 mb-3 text-4xl md:text-6xl line-height-1 font-bold color-orange">
                  Beleef het veld
                </h1>

                <p className="text-base md:text-lg lg:text-xl line-height-3 mb-4" style={{ maxWidth: '740px' }}>
                  Van yoga tussen de gewassen tot koken op open vuur, pizza uit de houtoven en een groot feest voor
                  10 jaar Groentegeweld. Kom proeven, leren, vertragen en vieren op ons veld.
                </p>

                <div className="flex flex-wrap gap-3">
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Voor jong en oud
                  </span>
                  <span className="px-3 py-2 border-round-3xl font-medium" style={{ background: 'rgba(255,255,255,0.22)' }}>
                    Op ons veld
                  </span>
                </div>
              </div>
            </Content>
          </div>
        </div>
      </section>

      <Content>
        <div className="py-5 md:py-6">
          <div className="mb-4 flex flex-column align-items-center text-center">
            <h2 className="mt-0 mb-2 text-xl md:text-3xl lg:text-4xl font-bold color-orange">
              Zet deze data alvast in je agenda
            </h2>

            <p className="m-0 text-base md:text-lg line-height-3" style={{ maxWidth: '760px' }}>
              Hieronder vind je alle geplande activiteiten. Voor sommige events volgt de praktische info nog, maar de datum
              kan je alvast vrijhouden.
            </p>
          </div>

          <div className="grid">
            {regularActivities.map(activity => (
              <div className="col-12 md:col-6 lg:col-4" key={activity.title}>
                <a
                  href={`#${getActivityId(activity)}`}
                  className={sectionCardClassName + ' h-full block no-underline color-inherit'}
                >
                  <div className="flex align-items-start gap-3 h-full">
                    <div
                      className="flex align-items-center justify-content-center border-round-xl color-white font-bold"
                      style={{
                        minWidth: '56px',
                        height: '56px',
                        color: 'var(--green)',
                      }}
                    >
                      <i className="pi pi-calendar text-2xl"/>
                    </div>

                    <div className={'flex flex-column gap-1 h-full flex-grow-1'}>
                      <div className="font-bold color-orange mb-1">{activity.date}</div>
                      {activity.time && <div className="text-sm text-gray-600 mb-1">{activity.time}</div>}
                      <div className="flex-grow-1 font-bold text-lg line-height-2">{activity.title}</div>
                      <div className={activityMoreInfoClassName}>
                        Meer info
                        <i className="pi pi-arrow-down text-xs"/>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
            {featuredActivity && (
              <div className="col-12" key={featuredActivity.title}>
                <a
                  href={`#${getActivityId(featuredActivity)}`}
                  className={sectionCardClassName + ' h-full block no-underline color-inherit'}
                >
                  <div className="flex align-items-center justify-content-center">
                  {times(3, index => (<div
                    className="flex align-items-center justify-content-center border-round-xl color-white font-bold"
                    style={{
                      minWidth: '56px',
                      height: '56px',
                      color: 'var(--orange)',
                    }}
                    key={index}
                  >
                    <i className="pi pi-star text-2xl"/>
                  </div>))}
                  </div>
                  <div className="flex align-items-center flex-column gap-3">
                      <div className="font-bold text-xl color-orange mb-1">{featuredActivity.date}</div>
                      {featuredActivity.time &&
                        <div className="text-sm text-gray-600 mb-1">{featuredActivity.time}</div>}
                      <div className="font-bold text-2xl line-height-2">{featuredActivity.title}</div>
                      <span className={activityMoreInfoClassName}>
                        Meer info
                        <i className="pi pi-arrow-down text-xs"/>
                      </span>
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>
      </Content>

      <Content>
        <div className="py-4 md:py-6">
          <div className="mb-4 flex flex-column align-items-center text-center">
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
              style={{background: 'var(--orange-20)'}}
            >
              <span className="font-medium">Alle activiteiten</span>
            </div>

            <h2 className="mt-0 mb-2 text-3xl md:text-4xl">
              Kom proeven, leren en genieten
            </h2>
          </div>

          <div className="grid">
            {regularActivities.map(activity => (
              <div className="col-12 lg:col-6" key={activity.title}>
                <article
                  id={getActivityId(activity)}
                  className={cardClassName + ' h-full flex flex-column'}
                >
                  <img
                    src={activity.image}
                    alt={activity.alt}
                    className="block w-full"
                    style={{height: '280px', objectFit: 'cover'}}
                  />

                  <div className="p-4 md:p-5 flex flex-column flex-grow-1">
                    <div className="flex-grow-1">
                      <div
                        className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-3"
                        style={{background: 'var(--green-20)'}}
                      >
                        <i className="pi pi-sparkles"/>
                        <span className="font-medium">{activity.eyebrow}</span>
                      </div>

                      <h3 className="mt-0 mb-3 text-3xl line-height-2">
                        {activity.title}
                      </h3>

                      <div className="flex flex-wrap gap-2 mb-4">
                        <span
                          className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl font-medium"
                          style={{
                            background: 'var(--orange-20)',
                            color: 'var(--orange)',
                          }}
                        >
                          <i className="pi pi-calendar"/>
                          {activity.date}
                        </span>

                        {activity.time && (
                          <span
                            className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl font-medium"
                            style={{
                              background: 'var(--green-20)',
                              color: 'var(--green)',
                            }}
                          >
                            <i className="pi pi-clock"/>
                            {activity.time}
                          </span>
                        )}
                      </div>

                      <p className="text-lg line-height-3 mb-3">
                        {activity.intro}
                      </p>

                      {activity.paragraphs.map(paragraph => (
                        <p className="line-height-3 mb-3" key={paragraph}>
                          {paragraph}
                        </p>
                      ))}

                      {activity.highlights && (
                        <div className="flex flex-wrap gap-2 mt-3 mb-4">
                          {activity.highlights.map(highlight => (
                            <span
                              className="px-3 py-2 border-round-3xl font-medium"
                              style={{background: 'var(--orange-20)'}}
                              key={highlight}
                            >
                              {highlight}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>

                    {activity.buttonLabel && (
                      <div className="mt-3">
                        <Button
                          label={activity.buttonLabel}
                          icon={activity.buttonDisabled ? undefined : "pi pi-external-link"}
                          iconPos="right"
                          className={activity.buttonDisabled ? "p-button-outlined" : "color-white bg-orange"}
                          onClick={activity.buttonDisabled ? undefined : () => window.open(activity.buttonUrl, '_blank')}
                          disabled={activity.buttonDisabled}
                        />
                      </div>
                    )}
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </Content>

      <section className="my-4 md:my-6">
        <Parallax img={'zonnebloem.jpg'} height={'240px'} />
      </section>

      <Content>
        <div className="py-4 md:py-6">
          <div
            className="border-round-2xl shadow-2 p-4 md:p-6 text-center"
            style={{
              background: 'linear-gradient(135deg, rgba(116, 143, 86, 0.18) 0%, rgba(238, 122, 49, 0.14) 100%)',
            }}
          >
            <div
              className="inline-flex align-items-center gap-2 px-3 py-2 border-round-3xl mb-4"
              style={{ background: 'rgba(255,255,255,0.65)' }}
            >
              <i className="pi pi-info-circle" />
              <span className="font-medium">Praktische info</span>
            </div>

            <h2 className="mt-0 mb-3 text-3xl md:text-4xl">
              Vragen over een activiteit?
            </h2>

            <p className="text-lg line-height-3 mx-auto mb-4" style={{ maxWidth: '720px' }}>
              Voor sommige activiteiten zijn de plaatsen beperkt. Schrijf je tijdig in of contacteer ons als je graag meer
              informatie krijgt over programma, prijs of toegankelijkheid.
            </p>

            <Button
              label="Mail ons je vraag"
              icon="pi pi-envelope"
              iconPos="right"
              className="color-white bg-orange p-button-lg"
              onClick={() => window.open('mailto:info@groentegeweld.be', '_blank')}
            />
          </div>
        </div>
      </Content>

      <Footer />
    </div>
  );
};

export default ActiviteitenPage;
